// © Microsoft Corporation. All rights reserved.

/**
 * An enumeration of all experiences ID.
 * By convention the experience ID ***MUST*** match exactly (including case) the class name for the experience.
 * NOTE: Keep this list alphabetical
 */
export enum ExperienceIds {
    animator = "Animator",
    articlePage = "ArticlePage",
    autosCard = "AutosCard",
    backgroundGradient = "BackgroundGradient",
    backgroundImageCommon = "BackgroundImageCommon",
    backgroundImageEdge = "BackgroundImageEdge",
    backgroundImageWC = "BackgroundImageWC",
    bannerManager = "BannerManager",
    baseHeader = "BaseHeader",
    bingAnswers = "BingAnswers",
    bingCards = "BingCardsExperience",
    bingHealth = "BingHealth",
    bingHealthCard = "BingHealthCard",
    bingHomepageFeed = "BingHomepageFeed",
    bingMiniShopping = "BingMiniShopping",
    bingShopping = "BingShopping",
    bingShoppingLifestyleCard = "BingShoppingLifestyleCard",
    bingShoppingMeStripe = "BingShoppingMeStripe",
    bingVideoCard = "BingVideoCard",
    bingVideoCarousel = "BingVideoCarousel",
    bingWebSSO = "BingWebSSO",
    blowout = "Blowout",
    breakingNews = "BreakingNews",
    breakingNewsWC = "BreakingNewsWC",
    calendarCard = "CalendarCard",
    cardAction = "CardAction",
    cardActionV2 = "CardActionV2",
    cardActionWC = "CardActionWC",
    clarity = "Clarity",
    coachmark = "Coachmark",
    coachmarkWC = "CoachmarkWC",
    coldStart = "ColdStart",
    coldStartUpsellCard = "ColdStartUpsellCard",
    coldStartWC = "ColdStartWC",
    comments = "Comments",
    commonHeader = "CommonHeader",
    commonHeaderWC = "CommonHeaderWC",
    complexContentPreview = "ComplexContentPreview",
    conditionalBanner = "ConditionalBanner",
    conditionalBannerWC = "ConditionalBannerWC",
    contentActionsToolbar = "ContentActionsToolbar",
    contentPreview = "ContentPreview",
    contentPreviewSlide = "ContentPreviewSlide",
    contentProvider = "ContentProvider",
    contentRelated = "ContentRelated",
    contentSharingToolbar = "ContentSharingToolbar",
    covidChatBot = "CovidChatBot",
    dailyBrief = "DailyBrief",
    dailyBriefWC = "DailyBriefWC",
    dashboardFallback = "DashboardFallback",
    dashboardSettings = "DashboardSettings",
    denseCard = "DenseCard",
    desktopFeed = "DesktopFeed",
    desktopFeedEdgeNextWC = "DesktopFeedEdgeNextWC",
    desktopFeedSingleColumnWC = "DesktopFeedSingleColumnWC",
    desktopFeedViewsWC = "DesktopFeedViewsWC",
    desktopFeedWC = "DesktopFeedWC",
    displayAds = "DisplayAds",
    displayAdsWC = "DisplayAdsWC",
    displayAdsWithContentFallback = "DisplayAdsWithContentFallback",
    edgeChromiumPageWC = "EdgeChromiumPageWC",
    edgeHeader = "EdgeHeader",
    edgeNextPage = "EdgeNextPage",
    edgePage = "EdgePage",
    edgePageSettings = "PageSettings",
    editorsChoicePromoCard = "EditorsChoicePromoCard",
    electionDelegateCounter = "ElectionDelegateCounter",
    electionEditorsNote = "ElectionEditorsNote",
    electionResultMap = "ElectionResultMap",
    electionResultsCard = "ElectionResultsCard",
    electionVisualizer = "ElectionVisualizer",
    elections = "Elections",
    enterpriseComplianceBanner = "EnterpriseComplianceBanner",
    enterpriseFeedContainerWC = "EnterpriseFeedContainerWC",
    enterpriseRightRail = "EnterpriseRightRail",
    entertainmentCard = "EntertainmentCard",
    entryPoint = "EntryPoint",
    entryPointEdgeNext = "EntryPointEdgeNext",
    esportsCard = "EsportsCard",
    esportsLiveStreamCard = "EsportsLiveStreamCard",
    esportsLivestreamCarouselWC = "EsportsLivestreamCarouselWC",
    eventHubHeroNav = "EventHubHeroNav",
    eventHubPage = "EventHubPage",
    externalContentPreview = "ExternalContentPreview",
    externalNativeAd = "ExternalNativeAd",
    familyCard = "FamilyCard",
    feedNavigationHeader = "FeedNavigationHeader",
    feedNavigationHp = "FeedNavigationHp",
    feedToggle = "FeedToggle",
    feedToggleWC = "FeedToggleWC",
    feedVisualizer = "FeedVisualizer",
    feedbackCard = "FeedbackCard",
    feedbackDialog = "FeedbackDialog",
    feedbackDialogWC = "FeedbackDialogWC",
    feedbackLink = "FeedbackLink",
    feedbackLinkWC = "FeedbackLinkWC",
    financeCardCommon = "FinanceCardCommon",
    financeCompanyProfileCard = "FinanceCompanyProfileCard",
    financeCurrencyConverter = "FinanceCurrencyConverter",
    financeDetailComposition = "FinanceDetailComposition",
    financeDetailHeader = "FinanceDetailHeader",
    financeDetailNavigation = "FinanceDetailNavigation",
    financeDetailPageV2 = "FinanceDetailPageV2",
    financeDetailsCard = "FinanceDetailsCard",
    financeDetailsCardV2 = "FinanceDetailsCardV2",
    financeDianomiAds = "FinanceDianomiAds",
    financeDiscoverySection = "FinanceDiscoverySection",
    financeEarningChart = "FinanceEarningChart",
    financeEarningsCalendarCard = "FinanceEarningsCalendarCard",
    financeEarningsCard = "FinanceEarningsCard",
    financeEarningsForecast = "FinanceEarningsForecast",
    financeEarningsReport = "FinanceEarningsReport",
    financeEventsCalendarCard = "FinanceEventsCalendarCard",
    financeFeeds = "FinanceFeeds",
    financeFeedsSection = "FinanceFeedsSection",
    financeFinancialsCard = "FinanceFinancialsCard",
    financeFollowButton = "FinanceFollowButton",
    financeIndicesCard = "FinanceIndicesCard",
    financeInvestorDetailPage = "FinanceInvestorDetailPage",
    financeInvestorHoldingsHighlight = "FinanceInvestorHoldingsHighlight",
    financeInvestorHoldingsTable = "FinanceInvestorHoldingsTable",
    financeInvestorPerformanceCard = "FinanceInvestorPerformanceCard",
    financeInvestorPerformanceGraph = "FinanceInvestorPerformanceGraph",
    financeInvestorProfileHeader = "FinanceInvestorProfileHeader",
    financeKeyFactsCard = "FinanceKeyFactsCard",
    financeL1TopStories = "FinanceL1TopStories",
    financeL3OwnershipEventsList = "FinanceL3OwnershipEventsList",
    financeL3OwnershipGraph = "FinanceL3OwnershipGraph",
    financeL3OwnershipHoldersTable = "FinanceL3OwnershipHoldersTable",
    financeL3PageComposition = "FinanceL3PageComposition",
    financeLandingPageV2 = "FinanceLandingPageV2",
    financeListDetailHeader = "FinanceListDetailHeader",
    financeListDetailPage = "FinanceListDetailPage",
    financeListLandingPage = "FinanceListLandingPage",
    financeMarketCard = "FinanceMarketCard",
    financeMarketMoversCard = "FinanceMarketMoversCard",
    financeMarketStatus = "FinanceMarketStatus",
    financeNewsCard = "FinanceNewsCard",
    financeNewsContent = "FinanceNewsContent",
    financeNotificationBar = "FinanceNotificationBar",
    financePortfolioList = "FinancePortfolioList",
    financeRecentlyViewedCard = "FinanceRecentlyViewedCard",
    financeRecommendationCard = "FinanceRecommendationCard",
    financeRecommendationCardV2 = "FinanceRecommendationCardV2",
    financeSearchBox = "FinanceSearchBox",
    financeTrendCard = "FinanceTrendCard",
    financeWatchlistCard = "FinanceWatchlistCard",
    financeWatchlistListView = "FinanceWatchlistListView",
    financeWatchlistManagement = "FinanceWatchlistManagement",
    financeWatchlistMiniView = "FinanceWatchlistMiniView",
    financeWatchlistPage = "FinanceWatchlistPage",
    financeWatchlistPageV2 = "FinanceWatchlistPageV2",
    firstPartyPage = "FirstPartyPage",
    fitnessSingleVideo = "FitnessSingleVideo",
    flyoutCard = "FlyoutCard",
    footerWindowsShell = "FooterWindowsShell",
    freMarketSelector = "FreMarketSelector",
    frequentSitesCardWC = "FrequentSitesCardWC",
    galleryPage = "GalleryPage",
    gameCard = "GameCard",
    generalElections = "GeneralElections",
    gmailEmailPreview = "GmailEmailPreview",
    headerNavigationLogo = "HeaderNavigationLogo",
    headerWindowsShell = "HeaderWindowsShell",
    healthFitnessVideoSeemore = "HealthFitnessVideoSeemore",
    healthFitnessWorkoutCard = "HealthFitnessWorkoutCard",
    hiddenContent = "HiddenContent",
    homePage = "HomePage",
    homepageFooter = "HomepageFooter",
    homepageHeader = "HomepageHeader",
    horoscopeAnswerCard = "HoroscopeAnswerCard",
    horoscopeAnswerCardWC = "HoroscopeAnswerCardWC",
    iframe = "IFrame",
    imageSearch = "ImageSearch",
    industryNewsCard = "IndustryNewsCard",
    infopane = "Infopane",
    interests = "Interests",
    interestsLeftRail = "InterestsLeftRail",
    interestsSearch = "InterestsSearch",
    interestsV1Wrapper = "InterestsV1Wrapper",
    interestsV2 = "InterestsV2",
    interestsV3 = "InterestsV3",
    interestsWC = "InterestsWC",
    languageToggle = "LanguageToggle",
    languageToggleWC = "LanguageToggleWC",
    layoutSwitcher = "LayoutSwitcher",
    layoutToggle = "LayoutToggle",
    legacySharingToolbar = "LegacySharingToolbar",
    localNews = "LocalNews",
    localNewsViewCard = "LocalNewsViewCard",
    locationContentCard = "LocationContentCard",
    locationSelector = "LocationSelector",
    locationTime = "LocationTime",
    lottery = "Lottery",
    marketAggregator = "MarketAggregator",
    marketSelector = "MarketSelector",
    meControl = "MeControl",
    meStripe = "MeStripe",
    meStripeWC = "MeStripeWC",
    mediaServices = "MediaServices",
    meetNow = "MeetNow",
    microsoftEdgeWidget = "MicrosoftEdgeWidget",
    microsoftFeedCard = "MicrosoftFeedCard",
    microsoftLogo = "MicrosoftLogo",
    microsoftNewsPage = "MicrosoftNewsPage",
    migrationConsent = "MigrationConsent",
    miniApps = "MiniApps",
    mmxPage = "MMXPage",
    mns = "Mns",
    mnsCreatorDashboard = "MnsCreatorDashboard",
    mobileFeed = "MobileFeed",
    modernRightRail = "ModernRightRail",
    moneyCard = "MoneyCard",
    moneyInfoCard = "MoneyInfoCard",
    moneyInfoCardWC = "MoneyInfoCardWC",
    msRewards = "MsRewards",
    msRewardsWC = "MsRewardsWC",
    msnSettingMenu = "MsnSettingMenu",
    myBriefRiverCard = "MyBriefRiverCard",
    nativeAd = "NativeAd",
    newsSegmentCarousel = "NewsSegmentCarousel",
    newsbarFeedFooter = "NewsbarFeedFooter",
    newsbarFeedWC = "NewsbarFeedWC",
    newsbarUpsell = "NewsbarUpsell",
    notificationBell = "NotificationBell",
    notificationBellWC = "NotificationBellWC",
    nudgeSpotlightCard = "NudgeSpotlightCard",
    office = "Office",
    officeDocumentsTableWC = "OfficeDocumentsTableWC",
    officeLeftRail = "OfficeLeftRail",
    onThisDayCard = "OnThisDayCard",
    onThisDayCardWC = "OnThisDayCardWC",
    oneFooter = "OneFooter",
    outlookEmailPreview = "OutlookEmailPreview",
    overlay = "Overlay",
    pageRefresh = "PageRefresh",
    partnerUpsellCard = "PartnerUpsellCard",
    partnerWidget = "PartnerWidget",
    personalizeNavButton = "PersonalizeNavButton",
    photoCard = "PhotoCard",
    pivotContent = "PivotContent",
    pivotContentV2 = "PivotContentV2",
    pivotContentWC = "PivotContentWC",
    pivotsNav = "PivotsNav",
    pivotsNavEdgeNext = "PivotsNavEdgeNext",
    pivotsNavV2 = "PivotsNavV2",
    pollsCard = "PollsCard",
    pollsCardWC = "PollsCardWC",
    portugueseElectionExperience = "PortugueseElectionExperience",
    poweredByLegend = "PoweredbyLegend",
    poweredByLegendWC = "PoweredbyLegendWC",
    preconsumptionArticleCardWC = "PreconsumptionArticleCardWC",
    proactiveCanvas = "ProactiveCanvas",
    productivityHub = "ProductivityHub",
    promoBanner = "PromoBanner",
    publisherCarousel = "PublisherCarousel",
    publishersManagement = "PublishersManagement",
    qna = "Qna",
    qnaFeed404Page = "QnaFeed404Page",
    qnaFeedCard = "QnaFeedCard",
    qnaFeedCardMenu = "QnaFeedCardMenu",
    qnaFeedCarousel = "QnaFeedCarousel",
    qnaFeedCategoriesMenu = "QnaFeedCategoriesMenu",
    qnaFeedExploreTopics = "QnaFeedExploreTopics",
    qnaFeedList = "QnaFeedList",
    qnaFeedMyTopics = "QnaFeedMyTopics",
    qnaFeedPage = "QnaFeedPage",
    qnaFeedRelatedQuestions = "QnaFeedRelatedQuestions",
    qnaFeedReportCard = "QnaFeedReportCard",
    qnaFeedSuggestedTopics = "QnaFeedSuggestedTopics",
    qnaFeedTopicDetail = "QnaFeedTopicDetail",
    qnaFeedTrendingQuestions = "QnaFeedTrendingQuestions",
    reactionBreakdownDialog = "ReactionBreakdownDialog",
    recipesCards = "RecipesCards",
    recipesFeed = "RecipesFeed",
    recipesSdCard = "RecipesSdCard",
    recipesSearch = "RecipesSearch",
    recipesSingleDetail = "RecipesSingleDetail",
    recipesSingleVideo = "RecipesSingleVideo",
    recommendedCardFeed = "RecommendedCardFeed",
    recommendedCardWC = "RecommendedCardWC",
    recommendedSearch = "RecommendedSearch",
    recommendedSearchBelowSearchBox = "RecommendedSearchBelowSearchBox",
    recommendedSearchCarousel = "RecommendedSearchCarousel",
    recommendedSearchCarouselWC = "RecommendedSearchCarouselWC",
    recommendedSites = "RecommendedSites",
    recommendedSitesWC = "RecommendedSitesWC",
    recommendedTopics = "RecommendedTopics",
    relatedArticleBlock = "RelatedArticleBlock",
    relatedSearchesCard = "RelatedSearchesCard",
    rightRail = "RightRail",
    rightRailCards = "RightRailCards",
    rightRailCarousel = "RightRailCarousel",
    river = "River",
    riverPlaceholder = "RiverPlaceholder",
    searchBoxCommon = "SearchBoxCommon",
    searchBoxEdge = "SearchBoxEdge",
    searchBoxEdgeNextWC = "SearchBoxEdgeNextWC",
    searchBoxWC = "SearchBoxWC",
    searchHistoryCommon = "SearchHistoryCommon",
    searchHistoryEdge = "SearchHistoryEdge",
    searchHistoryEdgeNextWC = "SearchHistoryEdgeNextWC",
    seeMoreButtonWindowsShell = "SeeMoreButtonWindowsShell",
    selectCarousel = "SelectCarousel",
    sentimentBarChart = "SentimentBarChart",
    sentimentLineChart = "SentimentLineChart",
    sentimentMap = "SentimentMap",
    sentimentResultCard = "SentimentResultCard",
    settingsDialogEdgeNextWC = "SettingsDialogEdgeNextWC",
    settingsDialogMsNews = "SettingsDialogMsNews",
    sharedState = "SharedState",
    sharepointNewsCard = "SharepointNewsCard",
    shopContentCarousel = "ShopContentCarousel",
    shoppingCardWC = "ShoppingCardWC",
    shoppingCarousel = "ShoppingCarousel",
    shoppingCarouselWC = "ShoppingCarouselWC",
    shoppingContentCard = "ShoppingContentCard",
    shoppingGrid = "ShoppingGrid",
    shoppingPage = "ShoppingPage",
    shoppingPageContent = "ShoppingPageContent",
    shoppingSmartList = "ShoppingSmartList",
    shoppingSmartListWC = "ShoppingSmartListWC",
    showFeed = "ShowFeed",
    simpleBanner = "SimpleBanner",
    slideShow = "SlideShow",
    smartList = "SmartList",
    social = "Social",
    socialBar = "SocialBar",
    socialBarWC = "SocialBarWC",
    socialComment = "SocialComment",
    socialProfile = "SocialProfile",
    socialProfileCard = "SocialProfileCard",
    socialProfileCarousel = "SocialProfileCarousel",
    socialRelatedSources = "SocialRelatedSources",
    socialRewardsPromotion = "SocialRewardsPromotion",
    socialSubscriptionBanner = "SocialSubscriptionBanner",
    socialSubscriptionNotification = "SocialSubscriptionNotification",
    socialSubscriptionOverlay = "SocialSubscriptionOverlay",
    socialSubscriptionOverlaySummary = "SocialSubscriptionOverlaySummary",
    socialSubscriptionPaywall = "SocialSubscriptionPaywall",
    socialSubscriptionUpsell = "SocialSubscriptionUpsell",
    socialSupportResult = "SocialSupportResult",
    socialTipHistory = "SocialTipHistory",
    socialTipIntroduction = "SocialTipIntroduction",
    socialTipPromotion = "SocialTipPromotion",
    socialTipSelection = "SocialTipSelection",
    sportsCard = "SportsCard",
    sportsCardWC = "SportsCardWC",
    sportsMatchupCard = "SportsMatchupCard",
    sportsOlympicCard = "SportsOlympicCard",
    sportsOlympicCardWC = "SportsOlympicCardWC",
    spotlight = "Spotlight",
    spotlightPreview = "SpotlightPreview",
    starterKit = "StarterKit",
    starterKitWC = "StarterKitWC",
    storyPage = "StoryPage",
    storySnippet = "StorySnippet",
    stripe = "Stripe",
    stripeFeed = "StripeFeed",
    stripeView = "StripeView",
    stripeWC = "StripeWC",
    summaryCardWC = "SummaryCardWC",
    superAppPage = "SuperAppHomepage",
    superappHeaderData = "SuperappHeaderData",
    tabbedInfopane = "TabbedInfopane",
    tabbedInfopaneTabPreview = "TabbedInfopaneTabPreview",
    taboolaRiver = "TaboolaRiver",
    themePicker = "ThemePicker",
    themePickerWC = "ThemePickerWC",
    tipsCard = "TipsCard",
    toast = "Toast",
    toastWC = "ToastWC",
    todoCardWC = "TodoCardWC",
    topSites = "TopSites",
    topSitesCommon = "TopSitesCommon",
    topSitesEdge = "TopSitesEdge",
    topSitesEdgeNextWC = "TopSitesEdgeNextWC",
    topSitesNewsbar = "TopSitesNewsbar",
    topicsHub = "TopicsHub",
    trafficCard = "TrafficCard",
    trafficCardWC = "TrafficCardWC",
    trafficMap = "TrafficMap",
    trafficPage = "TrafficPage",
    travelDestination = "TravelDestination",
    travelPage = "TravelPage",
    trendingNews = "TrendingNews",
    trendingNow = "TrendingNow",
    trendingNowWC = "TrendingNowWC",
    tripleCard = "TripleCard",
    ugcCreator = "UgcCreator",
    upnextPaddle = "UpnextPaddle",
    userInitiatedPageRefresh = "UserInitiatedPageRefresh",
    userProfileDisplay = "UserProfileDisplay",
    verticalLeftNav = "VerticalLeftNav",
    videoCard = "VideoCard",
    videoCardWC = "VideoCardWC",
    videoContent = "VideoContent",
    videoList = "VideoList",
    viewsArticle = "ViewsArticle",
    viewsContentHeader = "ViewsContentHeader",
    viewsGallery = "ViewsGallery",
    viewsNativeAd = "ViewsNativeAd",
    viewsPaddles = "ViewsPaddles",
    voiceSearch = "VoiceSearch",
    voiceSearchWC = "VoiceSearchWC",
    waffleWC = "WaffleWC",
    watch = "Watch",
    watchlistCard = "WatchlistCard",
    watchlistView = "WatchlistView",
    weatherCard = "WeatherCard",
    weatherCardWC = "WeatherCardWC",
    weatherCarousel = "WeatherCarousel",
    weatherData = "WeatherData",
    weatherForecast = "WeatherForecast",
    weatherInfoCard = "WeatherInfoCard",
    weatherLocationSearch = "WeatherLocationSearch",
    weatherMap = "WeatherMap",
    weatherMapGroupSwitcher = "WeatherMapGroupSwitcher",
    weatherMapMini = "WeatherMapMini",
    weatherMapPromotionCard = "WeatherMapPromotionCard",
    weatherMapLegendIndicator = "WeatherMapLegendIndicator",
    weatherOverview = "WeatherOverview",
    weatherOverviewV2 = "WeatherOverviewV2",
    weatherPage = "WeatherPage",
    weatherPageV2 = "WeatherPageV2",
    weatherRecommendation = "WeatherRecommendation",
    weatherToast = "WeatherToast",
    weatherTodayCard = "WeatherTodayCard",
    weatherTodayMini = "WeatherTodayMini",
    weatherTodayMiniWC = "WeatherTodayMiniWC",
    welcomeGreetingWC = "WelcomeGreetingWC",
    widgets = "Widgets",
    windowsOfficeFeed = "WindowsOfficeFeed",
    windowsPage = "WindowsPage",
    windowsShellColdStartBanner = "WindowsShellColdStartBanner",
    windowsShellContentPreview = "WindowsShellContentPreview",
    windowsShellRiver = "WindowsShellRiver",
    xfeed = "Xfeed",
    xfeedWC = "XfeedWC"
}
